/* eslint-disable */
import { useState, useEffect } from "react";
import { Form } from "react-final-form";
import BasicInvoiceDetailsForm from "./basicDetails";
import ProductDetails from "./productDetails";
import BankDetailsForm from "./bankDetails";
import FinalTotalForm from "../../invoice/components/finalTotal";
import useQuotationHook from "../useProforma";
import moment from "moment";
import alertify from "alertifyjs";
import { ToastContainer } from "react-toastify";
const AddQuotationForm = ({ isEdit, id, data }) => {
  const [menu, setMenu] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const { FetchInvoiceStatus } = useQuotationHook();
  const { status } = FetchInvoiceStatus();
  const invoice = window.INVOICE;
  useEffect(() => {
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("w-100"));
  }, []);

  const getSeletedCustomer = (value) => {
    if (!value) return null;
    return {
      value: value.id,
      label: value?.user?.full_name,
      data: value,
    };
  };

  const initialValues = isEdit
    ? {
        ...data,
        customer: getSeletedCustomer(data?.customer),
      }
    : {};

  function transformInvoicePayload(data) {
    // Make sure to import moment at the top of your file:

    return {
      reference: data.reference || "",
      customer_id: data.customer?.value || null,
      subject: data.subject || "",
      proforma_date: moment(data.proforma_date).format("YYYY-MM-DD"),
      due_date: moment(data.due_date).format("YYYY-MM-DD"),
      expiry_date: moment(data.expiry_date).format("YYYY-MM-DD"),
      customer_notes: data.customer_notes || "",
      terms: data.terms || "",
      signature_name: data.signature_name || invoice?.digital_signature_name,
      signature_image: data.signature_image || invoice?.digital_signature_image,
      discount_value: data.discount_value || 0,
      tax: data.tax || 0,
      items: (data.items || []).map((item) => ({
        product: item.product || null,
        quantity: item.quantity || 0,
        unit: item.unit || "",
        rate: item.rate || 0,
        discount: item.discount || 0,
      })),
    };
  }

  const onSubmit = (values) => {
    if (!values?.items || values?.items?.length === 0) {
      alertify.error("Please add at least one product.");
      return;
    }
    // Check if all required fields have values for each product
    const hasEmptyFields = values.items.some(
      (item) => !item.product || !item.quantity || !item.unit || !item.rate
    );

    if (hasEmptyFields) {
      alertify.error("Please fill all required fields for each product.");
      return;
    }
    const transformedValues = transformInvoicePayload(values);
    fetch(
      isEdit
        ? `/invoice/proforma-invoices-edit/${data?.id}/`
        : "/invoice/proforma-invoices-create/",
      {
        method: isEdit ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1],
        },
        credentials: "include",
        body: JSON.stringify(transformedValues),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Invoice added successfully:", data);
        window.location.href = `/invoice/proforma-invoices/`;
      })
      .catch((error) => {
        console.error("Error adding invoice:", error);
      });
  };

  const handleSendEmail = (e) => {
    setSendingEmail(true);
    e.preventDefault();
    fetch(`/invoice/proforma/${data?.id}/send-email/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Email sent successfully:", data);
        setSendingEmail(false);
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        setSendingEmail(false);
      });
  };
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <div className="page-wrapper">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>
                    {isEdit ? "Edit Proforma" : "Add Proforma"}
                  </h5>
                </div>
              </div>
              <Form
                onSubmit={onSubmit}
                initialValues={{
                  ...initialValues,
                  proforma_date: initialValues?.proforma_date
                    ? new Date(initialValues?.proforma_date)
                    : new Date(),
                  expiry_date: initialValues?.expiry_date
                    ? new Date(initialValues?.expiry_date)
                    : new Date(),
                  signature_name:
                    initialValues.signature_name ||
                    invoice?.digital_signature_name,
                  signature_image:
                    initialValues.signature_image ||
                    invoice?.digital_signature_image,
                  terms:
                    initialValues.terms || invoice?.invoice_terms_conditions,
                  items: initialValues?.items || [],
                }}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <BasicInvoiceDetailsForm
                      status={status?.status_choices || []}
                    />
                    <hr />
                    <ProductDetails />
                    <div className="form-group-item border-0 p-0">
                      <div className="row">
                        <BankDetailsForm />
                        <FinalTotalForm from={"quote"} />
                      </div>
                    </div>
                    <div className="add-customer-btns text-end">
                      <button
                        type="reset"
                        className="btn btn-primary cancel me-2"
                        onClick={() =>
                          (window.location.href = "/invoice/proforma-invoices/")
                        }
                        disabled={submitting || pristine || sendingEmail}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel me-2"
                        onClick={form.submit}
                        disabled={submitting}
                      >
                        Save
                      </button>
                      {isEdit && pristine && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={submitting || sendingEmail}
                          onClick={(e) => handleSendEmail(e)}
                        >
                          Send to customer
                          {sendingEmail && (
                            <i className="fas fa-spinner fa-spin ms-2"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </form>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddQuotationForm;
